import dayjs from "dayjs";
import React from "react";
import { getStorageUser } from "../../helpers/api_helper";
import { PROFILES } from "../../components/VerticalLayout/SidebarContent";
import { postSendAccesa } from "../../helpers/backend_helper";

const today = dayjs();

const checkIfIsModifiable = (minutesConfig, salida) => {
  const { date_time } = salida;

  if (!minutesConfig) return true;

  const dateTimeConfig = dayjs(date_time).add(minutesConfig, "minutes");

  if (today.isBefore(dateTimeConfig)) return true;

  return false;
};

const Columns = (
  addUpd,
  destroy,
  items,
  setItems,
  duplicateBranch,
  authUser,
  setModalDetail,
  modalDetail,
  setModalReturn,
  modalReturn,
  minutesToEditConfig,
  minutesToDeleteConfig,
  modalAccessa,
  setModalAccessa
) => {

  const [loading, setLoading] = React.useState(false);

  const duplicate = (row) => {
    duplicateBranch(row).then((response) => {
      if (response.status) {
        const newItem = response.branch;
        let array = [...items, newItem];
        array.sort((a, b) => {
          return a.id - b.id;
        });
        setItems(array);
      }
    });
  };

  const user = getStorageUser();

  let columns = [
    {
      id: "no",
      name: "No",
      selector: (row) => row.no,
      sortable: true,
      width: "80px",
    },
    {
      id: "user_id",
      name: "Analista",
      selector: (row) => row.user_name,
      sortable: true,
      width: "130px",
    },
    {
      id: "date",
      name: "Fecha",
      selector: (row) => row.date_time,
      sortable: true,
      width: "170px",
    },
    {
      id: "unit_name",
      name: "Unidad",
      selector: (row) => row.unit_name,
      sortable: true,
      width: "90px",
    },
    {
      id: "operator_name",
      name: "Operador",
      selector: (row) => row.operator_name,
      sortable: true,
    },
    {
      id: "destination",
      name: "Destino",
      selector: (row) => row.destination,
      sortable: true,
    },
    {
      id: "pasajeros",
      name: "Pasajeros/Niños",
      selector: (row) => {
        if ([PROFILES.Checador].includes(user.profile_id)) return '- / -';
        return (row.pasajeros ? Math.floor(row.pasajeros) : '-') + ' / ' + (row.pasajeros_ninos ? Math.floor(row.pasajeros_ninos) : '-');
      },
      sortable: true,
    },
    {
      id: "actions",
      name: "Acciones",
      width: "15%",
      button: true,
      cell: (row) => {
        const isEditable = checkIfIsModifiable(minutesToEditConfig, row);
        const isRemovable = checkIfIsModifiable(minutesToDeleteConfig, row);

        return (
          <div className="d-flex justify-content-between">
            {row?.remote_data &&
              <div className="pe-1">
                <button
                  className="btn btn-primary btn-sm"
                  title="Accessa Control"
                  disabled={loading}
                  onClick={() => {
                    setModalAccessa({
                      show: true,
                      id: row.id,
                      row: row,
                    });
                  }}
                >
                  <i className="fa fa-arrow-up"></i>
                </button>
              </div>
            }
            <div className="pe-1">
              <button
                className="btn btn-primary btn-sm"
                title="Detalle Salida"
                onClick={() =>
                  setModalDetail({
                    ...modalDetail,
                    show: true,
                    id: row.id,
                    title: `Salida ${row.no} - ${row.destination}`,
                  })
                }
              >
                <i className="fa fa-eye"></i>
              </button>
            </div>
            {![4].includes(authUser.profile_id) && (   // 4: Concesionario
              <>
                <div className="pe-1">
                  <button
                    className="btn btn-primary btn-sm"
                    title="Editar Salida"
                    onClick={() => addUpd(row)}
                    disabled={!isEditable}
                  >
                    <i className="fas fa-edit"></i>
                  </button>
                </div>
                {row.type === 1 &&
                  <div className="pe-1">
                    <button
                      className="btn btn-primary btn-sm"
                      title="Regreso de salidas"
                      onClick={() =>
                        setModalReturn({
                          ...modalReturn,
                          show: true,
                          id: row.id,
                          timeBase: row.timeBase,
                        })
                      }
                    >
                      <i className="fa fa-cog"></i>
                    </button>
                  </div>
                }
                <div className="pe-1">
                  <button
                    className="btn btn-danger btn-sm"
                    title="Eliminar Salida"
                    onClick={() => destroy(row.id)}
                    disabled={!isRemovable}
                  >
                    <i className="fas fa-trash"></i>
                  </button>
                </div>
              </>
            )}
          </div>
        );
      },
    },
  ];
  return columns;
};

export default Columns;

//vaneton beicli
